import { z } from "zod";
export const SucursalSchema = z.object({
    id: z.string().uuid(),
    nombre: z.string().min(1),
    direccion: z.string().nullable(),
    telefono: z.string().nullable(),
    logoUrl: z.string().nullable().optional(),
    iconoUrl: z.string().nullable().optional(),
    eslogan: z.string().nullable().optional(),
    mostrarNombreLogo: z.boolean().optional(),
    mostrarEsloganLogo: z.boolean().optional(),
    alturaLogoPx: z.coerce.number().optional(),
    anchuraLogoPx: z.coerce.number().optional(),
    encabezadoTicket: z.string().nullable().optional(),
    pieTicket: z.string().nullable().optional(),
    imprimirLogoTicket: z.boolean().optional(),
});
export const EditarSucursalSchema = z.object({
    nombre: z.string().min(1).max(120).optional(),
    direccion: z.string().max(200).nullable().optional(),
    // Número de WhatsApp donde llegan los pedidos del menú QR (sección Landing).
    // Solo dígitos, sin indicativo de país (se antepone "57" fijo, ver LandingPage).
    telefono: z
        .string()
        .regex(/^\d{7,15}$/, "Solo dígitos, sin espacios ni indicativo de país")
        .nullable()
        .optional(),
    logoUrl: z.string().nullable().optional(),
    iconoUrl: z.string().nullable().optional(),
    eslogan: z.string().max(200).nullable().optional(),
    mostrarNombreLogo: z.boolean().optional(),
    mostrarEsloganLogo: z.boolean().optional(),
    alturaLogoPx: z.coerce.number().min(24).max(150).optional(),
    anchuraLogoPx: z.coerce.number().min(60).max(600).optional(),
    encabezadoTicket: z.string().max(1000).nullable().optional(),
    pieTicket: z.string().max(1000).nullable().optional(),
    imprimirLogoTicket: z.boolean().optional(),
});
//# sourceMappingURL=sucursal.schema.js.map